import { REDUCER_NAME, STATEMENT_STATUS } from './constants';

import { getState as getDomainState } from '../selectors';

export const getState = state => getDomainState(state)[REDUCER_NAME];

export const getLoadingStatus = (state) => {
  try {
    const { loading } = getState(state);
    return loading;
  } catch (e) {
    return false;
  }
};

export const getStatements = (state) => {
  try {
    const { statements } = getState(state);
    return statements;
  } catch (e) {
    return [];
  }
};

export const getFromDate = (state) => {
  try {
    const { from } = getState(state);
    return from;
  } catch (e) {
    return 0;
  }
};

export const getToDate = (state) => {
  try {
    const { to } = getState(state);
    return to;
  } catch (e) {
    return 0;
  }
};

export const getStatus = (state) => {
  try {
    const { status } = getState(state);
    return status;
  } catch (e) {
    return STATEMENT_STATUS.OPEN;
  }
};
